import { DATES_FORMATS } from '@/utils/constants'

export function getTooltipFormatOfDate(timeMode) {
  return timeMode === 'week'
    ? DATES_FORMATS.FULL
    : timeMode === 'month'
      ? DATES_FORMATS.MONTH
      : DATES_FORMATS.DEFAULT
}
